var _circle, _path, _path2, _rect, _rect2, _rect3, _rect4, _path3, _circle2, _rect5, _path4, _rect6, _rect7, _path5, _rect8, _path6, _rect9, _rect10, _rect11, _rect12, _g, _rect13, _rect14, _rect15, _rect16, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 372,
    height: 372,
    viewBox: "0 0 372 372",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 186,
    r: 185.5,
    fill: "#F2F4F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.3018 48.524C85.3018 42.4909 90.1926 37.6001 96.2257 37.6001H233.079L265.341 70.8333L299.683 104.067V321.621C299.683 327.654 294.792 332.545 288.759 332.545H96.2257C90.1926 332.545 85.3018 327.654 85.3018 321.621V48.524Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M232.774 37.6001L265.183 70.3718L299.683 103.143H238.236C235.22 103.143 232.774 100.698 232.774 97.6815V37.6001Z",
    fill: "#E1E6EA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 105.784,
    y: 145.474,
    width: 172.051,
    height: 16.3858,
    rx: 8.19292,
    fill: "#F0F2F4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 105.784,
    y: 111.336,
    width: 88.7566,
    height: 17.7513,
    rx: 8.87566,
    fill: "#F0F2F4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 105.784,
    y: 178.245,
    width: 172.051,
    height: 16.3858,
    rx: 8.19292,
    fill: "#F0F2F4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 105.784,
    y: 211.245,
    width: 92.0512,
    height: 16.3858,
    rx: 8.19292,
    fill: "#F0F2F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M356.835 273.71C356.835 321.366 318.202 360 270.545 360C222.888 360 184.255 321.366 184.255 273.71C184.255 226.053 222.888 187.419 270.545 187.419C318.202 187.419 356.835 226.053 356.835 273.71Z",
    fill: "#F2F4F9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 69.0969,
    transform: "matrix(-1 0 0 1 270.754 273.918)",
    fill: "url(#paint0_124_2229)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 257.958,
    y: 182.813,
    width: 25.5915,
    height: 12.2839,
    fill: "#D1D7DD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M249.85 172.061C249.255 164.616 255.136 158.245 262.605 158.245H278.39C285.859 158.245 291.741 164.616 291.145 172.061C290.613 178.711 285.061 183.836 278.39 183.836H262.605C255.934 183.836 250.382 178.711 249.85 172.061Z",
    fill: "url(#paint1_linear_124_2229)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 268.706,
    y: 163.363,
    width: 3.07097,
    height: 15.3549,
    rx: 1.53549,
    fill: "url(#paint2_linear_124_2229)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 261.541,
    y: 163.363,
    width: 3.07097,
    height: 15.3549,
    rx: 1.53549,
    fill: "url(#paint3_linear_124_2229)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M254.454 164.935C254.411 164.08 255.093 163.363 255.949 163.363C256.776 163.363 257.446 164.033 257.446 164.86V177.538C257.446 178.19 256.918 178.718 256.266 178.718C255.637 178.718 255.118 178.225 255.087 177.597L254.454 164.935Z",
    fill: "url(#paint4_linear_124_2229)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 275.872,
    y: 163.363,
    width: 3.07097,
    height: 15.3549,
    rx: 1.53549,
    fill: "url(#paint5_linear_124_2229)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M283.038 164.86C283.038 164.033 283.708 163.363 284.535 163.363C285.391 163.363 286.073 164.08 286.03 164.935L285.397 177.597C285.365 178.225 284.847 178.718 284.218 178.718C283.566 178.718 283.038 178.19 283.038 177.538V164.86Z",
    fill: "url(#paint6_linear_124_2229)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 266.659,
    y: 213.011,
    width: 8.18927,
    height: 25.0796,
    rx: 4.09463,
    fill: "#B2BDC8"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 266.659,
    y: 309.234,
    width: 8.18927,
    height: 25.0796,
    rx: 4.09463,
    fill: "#B2BDC8"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 234.67,
    y: 269.824,
    width: 8.18927,
    height: 25.0796,
    rx: 4.09463,
    transform: "rotate(90 234.67 269.824)",
    fill: "#B2BDC8"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 331.406,
    y: 269.824,
    width: 8.18927,
    height: 25.0796,
    rx: 4.09463,
    transform: "rotate(90 331.406 269.824)",
    fill: "#B2BDC8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_124_2229)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.14195,
    height: 70.0732,
    rx: 3.07097,
    transform: "matrix(-0.883254 -0.468894 -0.468894 0.883254 301.838 223.568)",
    fill: "#1872E7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.3312,
    height: 6.14195,
    rx: 3.07097,
    transform: "matrix(-0.866025 -0.5 -0.5 0.866025 279.317 274.942)",
    fill: "#1872E7"
  }))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 199.844,
    y: 213.31,
    width: 20.7742,
    height: 14.1265,
    transform: "rotate(-45 199.844 213.31)",
    fill: "#D1D7DD"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 190.396,
    y: 211.394,
    width: 31.7334,
    height: 13.3076,
    rx: 6.65378,
    transform: "rotate(-45 190.396 211.394)",
    fill: "url(#paint7_linear_124_2229)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 20.7742,
    height: 14.1265,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 340.985 213.31)",
    fill: "#D1D7DD"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 31.7334,
    height: 13.3076,
    rx: 6.65378,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 350.432 211.394)",
    fill: "url(#paint8_linear_124_2229)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.545 342.086C308.308 342.086 338.921 311.473 338.921 273.71C338.921 235.946 308.308 205.333 270.545 205.333C232.782 205.333 202.169 235.946 202.169 273.71C202.169 311.473 232.782 342.086 270.545 342.086ZM354.276 273.71C354.276 319.953 316.788 357.441 270.545 357.441C224.301 357.441 186.814 319.953 186.814 273.71C186.814 227.466 224.301 189.978 270.545 189.978C316.788 189.978 354.276 227.466 354.276 273.71Z",
    fill: "url(#paint9_linear_124_2229)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.82 197.661C263 199.205 261.891 200.597 260.355 200.835C239.403 204.083 221.351 216.128 210.101 233.087C209.242 234.382 207.514 234.805 206.186 233.996C204.859 233.186 204.435 231.451 205.291 230.153C217.42 211.763 236.979 198.698 259.705 195.239C261.242 195.005 262.641 196.117 262.82 197.661Z",
    fill: "#E6F0FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M270.754 347.366C310.202 347.366 342.387 316.266 344.127 277.247C344.209 275.411 345.691 273.919 347.528 273.919C349.366 273.919 350.862 275.413 350.787 277.248C349.041 319.943 313.877 354.02 270.754 354.02C254.094 354.02 238.621 348.933 225.805 340.229C224.31 339.214 223.986 337.169 225.028 335.693C226.105 334.168 228.223 333.835 229.772 334.878C241.478 342.764 255.578 347.366 270.754 347.366Z",
    fill: "#004DB3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_124_2229",
    x: 254.068,
    y: 216.965,
    width: 51.492,
    height: 77.9825,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.88221,
    dy: 2.88221
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.84295
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0941176 0 0 0 0 0.447059 0 0 0 0 0.905882 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_124_2229"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_124_2229",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_124_2229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.0969 69.0969) rotate(-108.129) scale(69.8879)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945405,
    stopColor: "#C4C4C4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_124_2229",
    x1: 246.698,
    y1: 150.823,
    x2: 283.805,
    y2: 182.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#899BAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697D8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_124_2229",
    x1: 251.816,
    y1: 156.709,
    x2: 285.482,
    y2: 169.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C474D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#788B9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_124_2229",
    x1: 244.65,
    y1: 156.709,
    x2: 278.317,
    y2: 169.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C474D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#788B9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_124_2229",
    x1: 237.485,
    y1: 156.709,
    x2: 271.151,
    y2: 169.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C474D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#788B9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_124_2229",
    x1: 258.982,
    y1: 156.709,
    x2: 292.648,
    y2: 169.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C474D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#788B9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_124_2229",
    x1: 266.147,
    y1: 156.709,
    x2: 299.814,
    y2: 169.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C474D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#788B9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_124_2229",
    x1: 188.903,
    y1: 210.396,
    x2: 204.283,
    y2: 232.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#899BAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697D8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_124_2229",
    x1: -1.49334,
    y1: -0.998067,
    x2: 13.8863,
    y2: 20.7834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#899BAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697D8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_124_2229",
    x1: 242.886,
    y1: 346.178,
    x2: 322.299,
    y2: 236.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1872E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D9AFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.6f3051f7df0e458b2b643ecd31d7465a.svg";
export { ForwardRef as ReactComponent };